export type ScoreBarPreset = {
  // Counter
  counterWidth: string;
  counterHeight: string;
  counterBorder: string;
  counterRadius: string;
  counterShadowX: string;
  counterShadowY: string;
  counterWrapperWidth?: string;
  
  // Digit
  digitSize: string;
  textStroke: string;
  
  // Separator
  separatorWidth: string;
  separatorHeight: string;
  separatorRadius: string;
  separatorBorder: string;
  separatorShadow: string;
  
  // Layout
  gap?: string;
};

const toCSSVars = (preset: ScoreBarPreset): Record<string, string> => ({
  '--sb-counter-w': preset.counterWidth,
  '--sb-counter-h': preset.counterHeight,
  '--sb-counter-border': preset.counterBorder,
  '--counter-radius': preset.counterRadius,
  '--sb-counter-shadow-x': preset.counterShadowX,
  '--sb-counter-shadow-y': preset.counterShadowY,
  ...(preset.counterWrapperWidth && { '--counter-wrapper-w': preset.counterWrapperWidth }),
  
  '--sb-digit-size': preset.digitSize,
  '--text-stroke': preset.textStroke,
  
  '--sb-sep-w': preset.separatorWidth,
  '--sb-sep-h': preset.separatorHeight,
  '--sb-sep-radius': preset.separatorRadius,
  '--sb-sep-border': preset.separatorBorder,
  '--sb-sep-shadow': preset.separatorShadow,
  
  ...(preset.gap && { '--sb-gap': preset.gap }),
});

export const PRESETS = {
  result: toCSSVars({
    counterWidth: '110.86px',
    counterHeight: '187px',
    counterBorder: '1.48px',
    counterRadius: '16px',
    counterShadowX: '13.7px',
    counterShadowY: '17.13px',
    counterWrapperWidth: '125px',
    
    digitSize: '164px',
    textStroke: '6.43px',
    
    separatorWidth: '56px',
    separatorHeight: '18px',
    separatorRadius: '6px',
    separatorBorder: '2px',
    separatorShadow: '9px 10px 0px 1px rgba(0, 0, 0, 1.00), 9px 7px 0px 1px rgba(0, 0, 0, 1.00)',
    
    gap: '11px',
  }),
  
  popup: toCSSVars({
    counterWidth: '116px',
    counterHeight: '187px',
    counterBorder: '1.37px',
    counterRadius: '16px',
    counterShadowX: '12.65px',
    counterShadowY: '15.82px',
    
    digitSize: '151px',
    textStroke: '6.16px',
    
    separatorWidth: '51px',
    separatorHeight: '16px',
    separatorRadius: '5.54px',
    separatorBorder: '1.85px',
    separatorShadow: '9px 10px 0px 1px rgba(0, 0, 0, 1.00), 9px 7px 0px 1px rgba(0, 0, 0, 1.00)',
  }),
  
  inGame: toCSSVars({
    counterWidth: '44px',
    counterHeight: '74.8px',
    counterBorder: '0.59px',
    counterRadius: '11px',
    counterShadowX: '5.48px',
    counterShadowY: '6.85px',
    counterWrapperWidth: '50px',
    
    digitSize: '65.77px',
    textStroke: '5px',
    
    separatorWidth: '22.4px',
    separatorHeight: '7.2px',
    separatorRadius: '2.4px',
    separatorBorder: '0.59px',
    separatorShadow: '6px 5px 0px 1px rgba(0, 0, 0, 1.00)',
  }),

  popupSmall: toCSSVars({
    counterWidth: '76px',
    counterHeight: '117px',
    counterBorder: '1px',
    counterRadius: '10px',
    counterShadowX: '5px',
    counterShadowY: '6px',
    counterWrapperWidth: 'auto',
    
    digitSize: '70px',
    textStroke: '3px',
    
    separatorWidth: '25px',
    separatorHeight: '8px',
    separatorRadius: '3px',
    separatorBorder: '1px',
    separatorShadow: '4px 5px 0px 1px rgba(0, 0, 0, 1.00)',
  }),

  gameResultSmall: toCSSVars({
    counterWidth: '76px',
    counterHeight: '117px',
    counterBorder: '1px',
    counterRadius: '12px',
    counterShadowX: '7px',
    counterShadowY: '9px',
    counterWrapperWidth: 'auto',
    
    digitSize: '90px',
    textStroke: '3.5px',
    
    separatorWidth: '32px',
    separatorHeight: '10px',
    separatorRadius: '3.5px',
    separatorBorder: '1px',
    separatorShadow: '5px 6px 0px 1px rgba(0, 0, 0, 1.00)',
  }),
} as const;
